import types from './types'
import { removeDiacriticsAndSpecialChars } from '~/utils/Utils'

export const mutations = {
  [types.SET_BENEFICIARIES] (state, beneficiaries) {
    state.beneficiaries = beneficiaries || []
  },

  [types.CLEAR_BENEFICIARIES] (state) {
    state.beneficiaries = []
  },

  [types.ADD_BENEFICIARY] (state, payload) {
    const { beneficiary } = payload

    const index = state.beneficiaries.findIndex((b) => {
      const isGovIdSet = b.govId?.trim() && !b.isChild && !b.isForeigner
      const isPassportSet = b.passport?.trim() && !b.isChild && b.isForeigner
      const isGovIdGuardianSet = b.govIdGuardian?.trim() && b.isChild && !b.isForeigner
      const isPassportMotherSet = b.passportMother?.trim() && b.isChild && b.isForeigner

      return (
        (
          !isGovIdSet &&
          !isPassportSet &&
          !isGovIdGuardianSet &&
          !isPassportMotherSet &&
          removeDiacriticsAndSpecialChars(b.firstname) === removeDiacriticsAndSpecialChars(beneficiary.firstname) &&
          removeDiacriticsAndSpecialChars(b.lastname) === removeDiacriticsAndSpecialChars(beneficiary.lastname) &&
          b.dateOfBirth === beneficiary.dateOfBirth
        ) ||
        (isGovIdSet && b.govId?.trim() === beneficiary.govId) ||
        (isPassportSet && b.passport?.trim() === beneficiary.passport) ||
        (isGovIdGuardianSet && b.govIdGuardian?.trim() === beneficiary.govIdGuardian) ||
        (isPassportMotherSet && b.passportMother?.trim() === beneficiary.passportMother)
      )
    })

    if (index >= 0) {
      const updatedBeneficiary = {
        ...state.beneficiaries[index],
        ...beneficiary,
        email: state.beneficiaries[index].email || beneficiary.email,
        dateOfBirth: state.beneficiaries[index].dateOfBirth || beneficiary.dateOfBirth,
        gender: state.beneficiaries[index].gender || beneficiary.gender,
      }

      state.beneficiaries.splice(index, 1, updatedBeneficiary)
      payload.index = index
    } else {
      state.beneficiaries.push(beneficiary)
      payload.index = state.beneficiaries.length - 1
    }

    state.beneficiaries.forEach((b) => {
      if (!b.isOtherAddress) {
        b.mailingApartmentNumber = b.addressApartmentNumber
        b.mailingCity = b.addressCity
        b.mailingHouseNumber = b.addressHouseNumber
        b.mailingPostcode = b.addressPostcode
        b.mailingStreet = b.addressStreet
      }
    })
  },

  [types.EDIT_BENEFICIARY] (state, { index, beneficiary }) {
    state.beneficiaries.splice(index, 1, beneficiary)
  },

  [types.SET_QUOTE] (state, quote) {
    state.quote = quote
  },

  [types.CLEAR_QUOTE] (state) {
    state.quote = {}
  },

  [types.REMOVE_QUOTE] (state, { itemUid, editIndex }) {
    state.quote[itemUid].beneficiary.splice(editIndex, 1)
  },

  [types.UPSERT_QUOTE] (state, { item, beneficiaryIndex, editIndex = null }) {
    if (editIndex !== null) {
      state.quote[item.uid].beneficiary.splice(editIndex, 1, beneficiaryIndex)
    } else {
      state.quote[item.uid].beneficiary.push(beneficiaryIndex)
    }
  },
}
